import React from "react";
import "./purpelBtn.css";

export default function PurpelBtn({ text, onClick, icon }) {
  return (
    <button onClick={onClick} className="purpelBtn">
      {icon} {text}
    </button>
  );
}
